import { useAuth } from '../auth/AuthProvider';
import { useTheme } from '../hooks/useTheme';
import { ThemeSwatch } from '../components/ThemeSwatch';
import { THEMES } from '../lib/themes';

export const Profile = () => {
  const { user, previewUserId } = useAuth();
  const { theme, setTheme, syncing } = useTheme();
  const readOnly = previewUserId !== null;

  return (
    <div className="space-y-8">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">Profile</h1>
        <p className="mt-1 text-sm text-text-secondary">
          {user?.displayName} · {user?.email}
        </p>
      </header>

      <section aria-labelledby="appearance-heading" className="space-y-3">
        <div>
          <h2
            id="appearance-heading"
            className="text-[11px] font-semibold uppercase tracking-wider text-text-tertiary"
          >
            Appearance
          </h2>
          <p className="mt-1 text-sm text-text-secondary">
            {readOnly
              ? "You're previewing as another user. Theme changes are disabled."
              : 'Pick a theme. Saved to this device immediately and synced to your account.'}
          </p>
        </div>

        <div
          role="radiogroup"
          aria-label="Theme"
          className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3"
        >
          {THEMES.map((t) => (
            <ThemeSwatch
              key={t.id}
              theme={t}
              active={theme === t.id}
              disabled={readOnly || (syncing && theme === t.id)}
              onSelect={() => {
                if (readOnly) return;
                setTheme(t.id);
              }}
            />
          ))}
        </div>
      </section>
    </div>
  );
};
